import React, { useState } from "react";
import styles from "./Slide5.module.scss";
import { useIntl } from "react-intl";
import { messages } from "../../Introduction.messages";
import { Button } from "@src/lms/jelly/extensions/ui";
import { DolbyCinemaModal } from "../modals/DolbyCinema";
import { MixStageModal } from "../modals/MixStage";
export const Slide5: React.FC = () => {
  const { formatMessage } = useIntl();

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isModalVisible2, setIsModalVisible2] = useState(false);

  return (
    <div className={styles.slide4}>
      <h2 className={styles.title}>{formatMessage(messages.slide5Title)}</h2>
      <h3 className={styles.subtitle}>{formatMessage(messages.slide5Subtitle)}</h3>
      <div className={styles.content}>
        <div className={styles.contentItem}>
          <h3>{formatMessage(messages.slide5Title1)}</h3>
          <p>{` • ${formatMessage(messages.slide5Description1)}`}</p>
          <p>{` • ${formatMessage(messages.slide5Description2)}`}</p>
        </div>
        <div className={styles.contentItem}>
          <h3>{formatMessage(messages.slide5Title2)}</h3>
          <p>{` • ${formatMessage(messages.slide5Description3)}`}</p>
          <p>{` • ${formatMessage(messages.slide5Description4)}`}</p>
          <p className={styles.description5}>{formatMessage(messages.slide5Description5)}</p>
        </div>
      </div>
      <div className={styles.buttonContainer}>
        <Button className={styles.button} shape="round" onClick={() => setIsModalVisible(true)} icon="cil-camera">
          {formatMessage(messages.slide5Button1)}
        </Button>
        <Button className={styles.button} shape="round" onClick={() => setIsModalVisible2(true)} icon="cil-camera">
          {formatMessage(messages.slide5Button2)}
        </Button>
      </div>
      <DolbyCinemaModal visible={isModalVisible} onClose={() => setIsModalVisible(false)} />
      <MixStageModal visible={isModalVisible2} onClose={() => setIsModalVisible2(false)} />
    </div>
  );
};
